import React from "react";
import FormCom from "../../Components/InstructionsCom/FormCom";
import { PlayerAccountProvider } from "../../APIContext/PlayerAccountContext";
import { InstructionsContextProvider } from "../../APIContext/InstructionsContext";
import SEO from "../../Components/SEO";

function InstructionsForm() {
  const [showModalAdd, setShowModalAdd] = React.useState(false);
  return (
    <div
      className="bg-custom"
      style={{
        minHeight: "calc(100vh - var(--header-height))",
        ...(!showModalAdd ? { filter: "brightness(1.2)" } : {}),
      }}
    >
      <PlayerAccountProvider>
        <InstructionsContextProvider>
          <FormCom
            showModalAdd={showModalAdd}
            setShowModalAdd={setShowModalAdd}
          />
        </InstructionsContextProvider>
      </PlayerAccountProvider>
    </div>
  );
}

export default InstructionsForm;
